<template>
	<label :for="`checkbox-${name}`" class="bbox-checkbox-label display-block" style="cursor:pointer">
		<div class="display-flex container-checkbox">
			<input
				type="checkbox"
				:id="`checkbox-${name}`"
				:checked="value"
				:name="name"
				@change="$emit('input', $event.target.checked)"
			/>
			<div class="checkbox-icon">
				<b-icon v-if="value">
					<icon-remove-rectangle v-if="icon && icon === 'remove'" />
					<icon-check-box v-else />
				</b-icon>
				<b-icon v-else><icon-check-box-outline-blank /></b-icon>
			</div>
			<slot name="label" />
			<span :class="labelClasses" v-if="!$slots.label && !!label">{{ label }}</span>
		</div>
		<span class="input-error font-size-big red-base margin-top-tiny" v-if="!!error"
			><b-icon><icon-error-outline /></b-icon> {{ error }}</span
		>
	</label>
</template>

<script>
import BIcon from './Icon';
import BCheckBoxOutlineBlankIcon from './icons/IconCheckBoxOutlineBlank';
import IconCheckBox from './icons/IconCheckBox';
import IconRemoveRectangle from './icons/IconRemoveRectangle';
import IconErrorOutline from './icons/IconErrorOutline';

export default {
	name: 'b-checkbox',
	components: {
		BIcon,
		'icon-check-box-outline-blank': BCheckBoxOutlineBlankIcon,
		'icon-check-box': IconCheckBox,
		'icon-remove-rectangle': IconRemoveRectangle,
		'icon-error-outline': IconErrorOutline
	},
	props: {
		/**
		 * Name do checkbox
		 */
		name: {
			type: String,
			required: true
		},
		/**
		 * Valor do checkbox (padrão é false)
		 * @model
		 */
		value: {
			type: Boolean,
			default: false
		},
		/**
		 * Mensagem de erro
		 */
		error: {
			type: String,
			default: ''
		},
		/**
		 * Texto do label do checkbox
		 */
		label: {
			type: String,
			default: ''
		},
		/**
		 * Classes para estilizar o label
		 */
		labelClasses: {
			type: String,
			default: 'font-size-big ink semi-bold'
		},
		/**
		 * Ícone personalizado quando estado é marcado, caso não seja enviado, será usado o check
		 */
		icon: {
			type: String,
			default: null
		}
	}
};
</script>

<style scoped lang="scss">
.container-checkbox {
	align-items: flex-start;
}
input {
	display: none;
}
span.input-error {
	display: block;
	text-align: left;
	line-height: 1.2;
}
.checkbox-icon {
	margin-right: 5px;
	margin-top: -1.5px;
	font-size: 2rem;
}
</style>

<docs>
    BCheckbox

    ```js
			<bbox-checkbox class="margin-top-big" name="termsAccepted" v-model="termsAccepted" label="Concordo com os termos" />
			<bbox-checkbox class="margin-top-big" name="termsAccepted" v-model="termsAccepted">
					<div slot="label">
						<span class="font-size-big ink semi-bold">Li e aceito os <a href="">termos</a></span>
					</div>
			</bbox-checkbox>
		```
</docs>
